import { useMe } from "@podtrac/common/accounts";
import React from "react";
import { Helmet } from "react-helmet";
import Frame from "../shared/Frame";
import { useUpdateProfile } from "./user-queries";
import { Field, Form, Formik } from "formik";

const loadingValues = {
    name: "",
    email: "",
    password: ""
};

export default function EditProfile() {

    const { data: { me } = {} } = useMe();

    const updateProfile = useUpdateProfile();

    console.log({ me });

    return (
        <>
            <Helmet>
                <title>Edit Your Profile - Podtrac</title>
            </Helmet>
            {/*<Frame src={`/account/edit`} />*/}

            <h1>Edit Your Profile</h1>
            <Formik
                onSubmit={values => updateProfile.mutateAsync(values)}
                initialValues={me ?? loadingValues}
                enableReinitialize
            >
                <Form disabled={!me} style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1em",
                    alignItems: "flex-start",
                }}>

                    <label>
                        <div>Name</div>
                        <Field name="name" />
                    </label>

                    <label>
                        <div>Email</div>
                        <Field name="email" />
                    </label>

                    <button type="submit">Save</button>
                </Form>
            </Formik>
        </>
    );
}
